<h2>Total en Bitcoin</h2>
<h2>
  Ƀ{{ (exchangeRate$ | async)?.convertedAmount
  }}<small>{{ (exchangeRate$ | async)?.to }}</small>
</h2>
